import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { Button, createIcon } from '@blade/ui-kit'
import { Dialog, type DialogControlProps } from '@root/shared/ui-kit'

type AutoScaleDialogProps = {} & DialogControlProps

export const AutoScaleDialog: React.FC<AutoScaleDialogProps> = ({
  open,
  onOpenChange,
}) => {
  const { t } = useTranslation()

  return (
    <Root
      open={open}
      onOpenChange={onOpenChange}
      describedBy={t('settings.auto-scale-acknowledgment.title')}
    >
      <Dialog.Header title={t('settings.auto-scale-acknowledgment.title')} />
      <Content>
        <IconContainer>
          <Icon size={20} />
        </IconContainer>
        <Description>
          {t('settings.auto-scale-acknowledgment.description')}
        </Description>
        <DescriptionSub>
          {t('settings.auto-scale-acknowledgment.description-2')}
        </DescriptionSub>
        <Button
          size="h28"
          radius="rounded"
          variant="soft"
          color="gray"
          onClick={() => onOpenChange?.(false)}
        >
          {t('common.continue')}
        </Button>
      </Content>
    </Root>
  )
}

const Root = styled(Dialog)`
  width: 320px;
`

const Content = styled.div`
  display: flex;
  flex-direction: column;

  display: grid;
  justify-content: center;
  justify-items: center;
  gap: 13px;

  padding-inline: 16px;
  padding-block: 22px;
  font-size: 14px;

  text-align: center;
`

const IconContainer = styled.div`
  width: 38px;
  height: 38px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  justify-self: center;
  background: var(--backgroundA-4);
`

const Icon = createIcon(
  <>
    <path
      d="M9.1665 1.66666C5.78728 1.67274 4.01775 1.75571 2.8869 2.88656C1.6665 4.10695 1.6665 6.07114 1.6665 9.99949C1.6665 13.9279 1.6665 15.8921 2.8869 17.1125C4.10728 18.3328 6.07147 18.3328 9.99984 18.3328C13.9282 18.3328 15.8924 18.3328 17.1128 17.1125C18.2437 15.9816 18.3266 14.2121 18.3327 10.8328"
      stroke="white"
      strokeLinecap="round"
    />
    <path
      d="M10.8333 9.16666L18.3333 1.66666M18.3333 1.66666H13.8802M18.3333 1.66666V6.11978M17.5 2.49999L10 9.99999M10 9.99999H13.3333M10 9.99999V6.66666"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  '0 0 20 20',
)

const Description = styled.div`
  color: var(--text-12);
  text-align: center;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
`

const DescriptionSub = styled(Description)`
  color: var(--text-10);
`
